import { AUTH_TOKEN_KEY, GET_SURVEY, GET_USER_PREFERENCE, POST_SURVEY } from '../constants';
import api from '../utils/Api';

const ROUTE_API = '/users/survey'

export const getSurvey = (query) => ({
  type: GET_SURVEY,
  payload: api({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
  })
    .get(ROUTE_API, { params: query })
    .then(res => res.data)
});

export const postSurvey = (surveyData) => ({
  type: POST_SURVEY,
  payload: api({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
  })
    .post(ROUTE_API, surveyData)
    .then(res => res.data)
});

export const getUserPreference = () => ({
  type: GET_USER_PREFERENCE,
  payload: api({
    Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN_KEY)}`,
  })
    .get('/users/preferences')
    .then(res => res.data)
})